/**
 * Whether a permission is held once for the whole platform or separately for
 * each society an admin belongs to.
 */
export enum PermissionScope {
  /** Stored on the admin user and applies everywhere. */
  global = "global",
  /** Stored per society, so an admin can hold it in one society and not another. */
  society = "society",
}
